import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable,  } from 'rxjs';

import { GroupService } from './group.service';

@Component({
  selector: 'group-parent',
  templateUrl: './group-parent.component.html',
  styleUrls: ['./group-parent.component.scss']
})
export class GroupParentComponent implements OnInit {
  group$: Observable<any>
  links = [
    {
      route: ['dashboard'],
      title: 'Dashboard',
    },
    {
      route: ['contacts'],
      title: 'Contacts',
      children: [
        {
          route: ['contact/specialty-list'],
          title: 'Specialties',
        },
        {
          route: ['contact/insurance-list'],
          title: 'Insurances',
        },
        {
          route: ['contact/department-list'],
          title: 'Departments',
        },
        {
          route: ['contact/regions'],
          title: 'Regions',
        }
      ]
    },
    {
      route: ['facilities'],
      title: 'Facilities',
      children: [
        {
          route: ['facility/insurance-list'],
          title: 'Insurances',
        },
        {
          route: ['facility/department-list'],
          title: 'Departments',
        },
        {
          route: ['facility/regions'],
          title: 'Regions',
        },
        {
          route: ['facility/city-list'],
          title: 'Cities',
        }
      ]
    },
    {
      route: ['languages'],
      title: 'Languages',
    }
  ]
  constructor(
    private gs: GroupService,
  ) {
  }

  ngOnInit() {
    this.group$ = this.gs.getGroup()
  }
}
